import { render, staticRenderFns } from "./CalendarioVendaEvento.vue?vue&type=template&id=3d5a5324&scoped=true"
import script from "./CalendarioVendaEvento.vue?vue&type=script&lang=js"
export * from "./CalendarioVendaEvento.vue?vue&type=script&lang=js"
import style0 from "./CalendarioVendaEvento.vue?vue&type=style&index=0&id=3d5a5324&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a5324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5a5324')) {
      api.createRecord('3d5a5324', component.options)
    } else {
      api.reload('3d5a5324', component.options)
    }
    module.hot.accept("./CalendarioVendaEvento.vue?vue&type=template&id=3d5a5324&scoped=true", function () {
      api.rerender('3d5a5324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/CalendarioVendaEvento.vue"
export default component.exports